import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { ClientContextType } from 'src/contexts/Client/types';
import { RootState } from 'src/reducers/store';
import { UserDataType } from 'src/types';
import { FullPageSpinner } from 'src/ui';
import {
  ApiPublicationResponseType,
  ApiPublicationType,
  EditFormBody,
} from '../../types';
import FormView from './FormView';
import * as actions from '../../../../actions/eventActions';
import { connect } from 'react-redux';

const EditForm: React.FC<{
  eventId: string;
  updateEvent: (
    id: string,
    body: EditFormBody,
    successCallback: () => void,
    failureCallback: () => void
  ) => void;
  onSuccess: () => void;
  closeModal: () => void;
  clientContext: ClientContextType;
  me: UserDataType;
}> = ({ eventId, updateEvent, onSuccess, closeModal, clientContext, me }) => {
  const { get } = clientContext;
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState<ApiPublicationType | undefined>(undefined);

  useEffect(() => {
    return get(`/events/${eventId}`, (response: ApiPublicationResponseType) => {
      if (!response.data) return;

      setEvent(response.data);
    });
  }, [get, eventId]);

  const onSubmit = (body: EditFormBody) => {
    delete body.publisher;

    setLoading(true);
    updateEvent(
      eventId,
      body,
      () => {
        setLoading(false);
        message.success('La publication a bien été mise à jour');
        onSuccess();
        closeModal();
      },
      () => {
        setLoading(false);
        message.error(
          'Une erreur est survenue lors de la mise à jour de la publication'
        );
      }
    );
  };

  return event ? (
    <FormView
      onSubmit={onSubmit}
      loading={loading}
      event={event}
      isMine={event.author.id === me.id}
    />
  ) : (
    <FullPageSpinner />
  );
};

const mapStateToProps = ({ client, me }: RootState) => ({
  clientContext: client,
  me,
});

export default connect(mapStateToProps, actions)(EditForm);
